import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UploadMultipleFilesWithContentModalComponent } from '@components/upload-multiple-files-with-content-modal/upload-multiple-files-with-content-modal.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ChannelTypeEnum } from 'src/app/enums/channel-type.enum';
import {
  EhrTypeEnum,
  UploadedPrescriptionType,
} from 'src/app/enums/ehr-type.enum';
import { PrescriptionTypeEnum } from 'src/app/enums/prescription-type.enum';
import { showNotification } from 'src/app/helpers/show-toast';
import { IFile } from 'src/app/_interfaces/files/i-files';
import { IEmrPrescription } from 'src/app/_interfaces/patients/i-emr-prescription';
import { EhrPrescriptionFilesServiceService } from 'src/app/_services/patient-emr/ehr-prescription-files-service.service';
import { PatientEmrDetailsService } from 'src/app/_services/patient-emr/patient-emr-details.service';

@Component({
  selector: 'emr-medications',
  templateUrl: './emr-medications.component.html',
  styleUrls: ['./emr-medications.component.scss'],
})
export class EmrMedicationsComponent implements OnInit {
  patientId: string = '';
  prescriptionList: IEmrPrescription[] = [];
  prescriptionThead = [
    'CREATION DATE',
    'CHANNEL',
    'NO. OF MEDICATIONS',
    'Doctor NAME / PRESCRIPTION TITLE',
    'NOTE',
    'EHR TYPE',
  ];
  prescriptionCreatorType: number = null;
  pageSize: number = 20;
  currentPage: number = 1;
  totalPages: number = 1;
  modalRef: BsModalRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private patientEmrDetailsService: PatientEmrDetailsService,
    private modalService: BsModalService,
    private datePipe: DatePipe,
    private ehrPrescriptionilesServiceService: EhrPrescriptionFilesServiceService,
    private toastr: ToastrService,
  ) {
    this.patientId = this.route.snapshot.params.patientId;
    this.prescriptionCreatorType = PrescriptionTypeEnum.all;
  }

  ngOnInit(): void {
    this.getEmrPrescriptions(
      this.patientId,
      PrescriptionTypeEnum.all,
      this.currentPage,
      this.pageSize
    );
  }

  get prescriptionTypeEnum() {
    return PrescriptionTypeEnum;
  }

  getEmrPrescriptions(
    patientId,
    prescriptionCreatorType,
    currentPage,
    pageSize
  ) {
    this.patientEmrDetailsService
      .getPatientEhrPrescriptions(
        patientId,
        prescriptionCreatorType,
        currentPage,
        pageSize
      )
      .subscribe((response) => {
        this.prescriptionList = this.prescriptionList.concat(
          response?.data?.items
        );
        this.currentPage = response?.data?.pagination.currentPage;
        this.totalPages = response?.data?.pagination.totalPages;
      });
  }

  onGetPrescriptions(filterType) {
    this.currentPage = 1;
    this.prescriptionList = [];
    this.prescriptionCreatorType = filterType;
    this.getEmrPrescriptions(
      this.patientId,
      filterType,
      this.currentPage,
      this.pageSize
    );
  }

  handlePrescriptionPagination() {
    if (this.currentPage < this.totalPages) {
      this.currentPage += 1;

      this.getEmrPrescriptions(
        this.patientId,
        this.prescriptionCreatorType,
        this.currentPage,
        this.pageSize
      );
    }
  }

  getChannelType(channelId) {
    if (channelId == ChannelTypeEnum.application) return 'Application';
    else if (channelId == ChannelTypeEnum.admin) return 'Admin';
    else if (channelId == ChannelTypeEnum.portal) return 'Portal';
    return '--';
  }

  getEhrType(ehrTypeIds, uploadedPrescriptionTypeId) {
    if (ehrTypeIds[0] === EhrTypeEnum.UploadedPrescriptionTypeId) {
      if (
        uploadedPrescriptionTypeId ==
        UploadedPrescriptionType.TpaRequestUploadedPrescriptionTypeId
      )
        return 'Approvals, Reimbursement';
      else if (
        uploadedPrescriptionTypeId ==
        UploadedPrescriptionType.PrescriptionFulfillmentUploadedPrescriptionTypeId
      )
        return 'Prescriptions , Prescription Tests';
      else if (uploadedPrescriptionTypeId == UploadedPrescriptionType.UploadedPrescriptionUploadedPrescriptionTypeId)
        return 'Prescription File';
    } else {
      let ehrTypeArr = [];
      ehrTypeIds.forEach((id) => {
        if (id === EhrTypeEnum.DoctorPrescriptionTypeId)
          ehrTypeArr.push('Doctor Prescription');
        else if (id === EhrTypeEnum.TestRequestTypeId)
          ehrTypeArr.push('Test Request');
        else if (id === EhrTypeEnum.PatientMedicationTypeId)
          ehrTypeArr.push('Patient Medication');
        else if (id === EhrTypeEnum.DiagnosisTypeId)
          ehrTypeArr.push('Diagnosis');
        else if (id === EhrTypeEnum.AllergyTypeId) ehrTypeArr.push('Allergy');
        else if (id === EhrTypeEnum.DiseaseTypeId) ehrTypeArr.push('Disease');
      });

      return ehrTypeArr.join(', ');
    }

    return '--';
  }

  onEmrPrescriptionDetails(
    isClickable,
    prescriptionSourceType,
    prescriptionId
  ) {
    if (isClickable) {
      this.router.navigate([
        'patient-details',
        this.patientId,
        'medications',
        prescriptionSourceType,
        prescriptionId,
      ]);
    }
  }

  viewFiles(event, prescription) {
    event.stopPropagation();

    let files: IFile[] = prescription.attachmentUrls.map(a => {
      return {
        id: a.id,
        path: a.path,
        isEditable: true,
      }
    })

    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered',
      initialState: {
        title: 'Upload Files',
        subtitle: 'Please add date for this file then upload files',
        filesExisted: files,
        isUploadable: true,
        isHaveContent: true,
        testDate: this.datePipe.transform(prescription.creationDate, "yyyy-MM-dd"),
        isUpdate: true
      }
    };

    this.modalRef = this.modalService.show(
      UploadMultipleFilesWithContentModalComponent,
      initialState
    );

    this.modalRef.content.event.subscribe((response) => {
      if (response.action === 'deleteFile') {
        this.deletePrescriptionFilesAddedByAdmin(prescription.id, response.file.id);
      }

      if (response.action === 'uploadFiles') {
        this.updateEhrPrescriptionFileByAdmin(prescription.id, response.testDate, response.filesToUpload, prescription.title);
      }
    });
  }

  deletePrescriptionFilesAddedByAdmin(ehrTransactionId, fileId) {
    this.ehrPrescriptionilesServiceService.deletePrescriptionFilesAddedByAdmin(ehrTransactionId, fileId)
      .subscribe((res) => {
        if (res.data.flag) {
          let prescriptionListAttachments = this.prescriptionList.find(t => t.id == ehrTransactionId).attachmentUrls;
          this.prescriptionList.find(t => t.id == ehrTransactionId).attachmentUrls = prescriptionListAttachments.filter(t => t.id != fileId);
          showNotification('success', 'file is deleted successfully', this.toastr);
        }
        else {
          showNotification('danger', res.errorList[0].message, this.toastr);
        }
      });
  }

  updateEhrPrescriptionFileByAdmin(ehrTransactionId, testDate, files, ehrTransactionTestDate) {
    if (!files.length
      && (this.datePipe.transform(testDate, 'yyyy-MM-dd') == this.datePipe.transform(ehrTransactionTestDate, 'yyyy-MM-dd')))
      return;
    this.ehrPrescriptionilesServiceService.updateEhrPrescriptionFileByAdmin(ehrTransactionId,
      testDate, files)
      .subscribe((res) => {
        if (res.data) {
          this.prescriptionList.find(t => t.id == ehrTransactionId).attachmentUrls = res.data.attachmentUrls;
          showNotification('success', 'Prescription is updated successfully', this.toastr);
        }
        else {
          showNotification('danger', res.errorList[0].message, this.toastr);
        }
        this.modalRef.hide();
      });
  }
}
